import type { FullParcel } from '@coig/apm-api';
import { IonCard, IonCardContent, IonCardHeader, IonIcon } from '@ionic/react';
import { chevronForwardOutline } from 'ionicons/icons';
import React from 'react';
import { useHistory } from 'react-router';
import { states } from '../../../../utilities/states';
import { DateTime} from 'luxon';
import '../Package.css';

const packageSentListElement: React.FC<FullParcel & { ref: any}> = React.forwardRef<HTMLIonCardElement, FullParcel>(({ status, id, receiver, parcelName, statusModificationTime }, cardRef) => {
  const history = useHistory();
  return (
    <IonCard className={status.toLowerCase().includes('ready') ? 'ready' : status.replaceAll('_', '-').toLowerCase()} ref={cardRef as any}>
      <div className='anchor'>&nbsp;</div>
      <div className="clickable-area" onClick={() => history.push(`/sent-packages/put-package/${id}`)}>
        <IonCardHeader>
          <h2>Parcel: Wien Mitte Landstraße</h2>
          <h2>ID: {id}</h2>
        </IonCardHeader>
        <IonCardContent>
          <div>
            <p>Recipient:</p>
            <h1>{receiver?.name} {receiver?.surname}</h1>
          </div>
          <div>
            <p>Name:</p>
            <h1>{parcelName}</h1>
          </div>
        </IonCardContent>
        <div className='state-bar'>
          <div className="state-bar-left">
            <span>State:</span>
            <h3>{states(status, 'sender')}</h3>
          </div>
          <div className="state-bar-right">
            {status === 'SENT' || status === 'RECEIVED' ?
              <>
                <span>Last change:</span>
                <h3 className='date-time'>{DateTime.fromISO(statusModificationTime).setLocale('en').toLocaleString(DateTime.DATETIME_SHORT)}</h3>
              </>
              :
              <>
                <span>Time to placement:</span>
                <h3>48 hours</h3>
              </>
            }

          </div>
          <div className="state-bar-icon">
            <IonIcon icon={chevronForwardOutline} />
          </div>
        </div>
      </div>
    </IonCard>
  );
});

export { packageSentListElement as PackageSentListElement };
